export const FileTypes: { [key: string]: { name: string; icon: string } } = {
	'': {
		name: 'document_types_no_document_type',
		icon: 'no-document-type',
	},
	REPORT: {
		name: 'document_types_report',
		icon: 'report',
	},
	SERVICE_AGREEMENT: {
		name: 'document_types_contract',
		icon: 'handshake',
	},
	USER_MANUAL: {
		name: 'document_types_manual',
		icon: 'demography',
	},
	REGULATION: {
		name: 'document_types_regulation',
		icon: 'gavel',
	},
	DRAWING: {
		name: 'document_types_drawing',
		icon: 'stylus_note',
	},
	IMAGE: {
		name: 'document_types_image',
		icon: 'image',
	},
};
